<template>
  <g>
    <g v-if="ann.type === 'rect'"
       class="rect"
    >
      <rect
        :height="loc.height"
        :width="loc.width"
        :x="loc.left"
        :y="loc.top"
      />
      <g class="rect-border">
        <line
          class="top"
          :x1="loc.left" :y1="loc.top" :x2="loc.left + loc.width" :y2="loc.top"
        />
        <line
          class="bottom"
          :x1="loc.left" :y1="loc.top + loc.height" :x2="loc.left + loc.width" :y2="loc.top + loc.height"
        />
        <line
          class="left"
          :x1="loc.left" :y1="loc.top" :x2="loc.left" :y2="loc.top + loc.height"
        />
        <line
          class="right"
          :x1="loc.left + loc.width" :y1="loc.top" :x2="loc.left + loc.width" :y2="loc.top + loc.height"
        />
        <circle
          class="highlight-vertex tl"
          :cx="loc.left" :cy="loc.top" r="7"
        />
        <circle
          class="highlight-vertex tr"
          :cx="loc.left + loc.width" :cy="loc.top" r="7"
        />
        <circle
          class="highlight-vertex br"
          :cx="loc.left + loc.width" :cy="loc.top + loc.height" r="7"
        />
        <circle
          class="highlight-vertex bl"
          :cx="loc.left" :cy="loc.top + loc.height" r="7"
        />
      </g>
    </g>
    <circle v-if="ann.type === 'point'"
      :cx="loc.left"
      :cy="loc.top"
      r="10"
      class="comment-circle"
    />
    <text v-if="ann.type === 'point'"
      :x="loc.left"
      :y="loc.top"
      text-anchor="middle"
      stroke="#ffffff"
      stroke-width="1px"
      dy=".3em"
    >{{ commentNum }}</text>
    <g v-if="ann.type === 'measure'"
    >
      <circle
        class="vertex"
        :cx="loc.left"
        :cy="loc.top"
        r="1"
      />
      <line
        :x1="loc.left" :y1="loc.top" :x2="loc.left + loc.width" :y2="loc.top + loc.height"
        class="ruler"
      />
      <circle
        class="vertex"
        :cx="loc.left + loc.width"
        :cy="loc.top + loc.height"
        r="1"
      />
    </g>
    <g v-if="ann.type === 'draw'">
      <circle
        v-for="line in lines"
        class="draw-vertex"
        :cx="line.x1"
        :cy="line.y1"
        r="2"
      />
      <line
        class="draw-line"
        v-for="line in lines"
        :x1="line.x1"
        :y1="line.y1"
        :x2="line.x2"
        :y2="line.y2"
      />
      <circle
        v-for="line in lines"
        class="draw-vertex"
        :cx="line.x2"
        :cy="line.y2"
        r="2"
      />
    </g>
  </g>
</template>

<script>
import { location, draw } from 'shared/annotations.js';

export default {
  name: 'Annotation',
  props: [
    'ann',
    'imageToDisplayFactor',
    'allAnnotations',
  ],
  computed: {
    commentNum() {
      return this.allAnnotations
        .filter(a => a.type === 'point')
        .map(a => a.id)
        .indexOf(this.ann.id) + 1 || '';
    },
    loc() { return location(this.ann, this.imageToDisplayFactor); },
    lines() { return draw(this.loc); },
  },
};
</script>
<style lang="scss" scoped>
  rect {
    stroke-width: 5;
    stroke: gainsboro;
    fill: transparent;
    circle {
      opacity: 0;
    }
  }
  g {
    circle {
      fill: red;
      user-select: none;
    }
    g.draw-vertex {
      stroke: red;
    }
    .highlight-vertex {
      opacity: 0;
    }
    .vertex {
      opacity: 1;
    }
  }
  .draw-line {
    stroke-width: 5;
    stroke: red;
  }
  .vertex {
    fill: rgb(154, 205, 241) !important;
  }
  svg {
    g.annotation {
      cursor: move;
    }
    .left, .right, .vertex {
      cursor: ew-resize;
    }
    .top, .bottom {
      cursor: ns-resize;
    }
    rect, .ruler, .draw-vertex, .draw-line  {
      cursor: move;
    }
    .tr, .bl{
      cursor: nesw-resize;
    }
    .tl, .br {
      cursor: nwse-resize;
    }
  }
  .rect-border {
    line {
      stroke-width: 4;
      opacity: 0;
    }
    circle {
      opacity: 0;
    }
  }
  .ruler {
    stroke-width: 4;
    stroke: rgb(154, 205, 241);
    stroke-dasharray: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/Annotation.vue